import React, { useState } from 'react'
import { Nav, Tab } from 'react-bootstrap'
import General from './general'
import Region from './region'
import { getUserRole, hasAccess } from '../../helper/function'

const Reports = () => {
  const [activeKey, setActiveKey] = useState(hasAccess('reportGeneralTab', getUserRole()) ? 'general' : 'region') // track active tab

  const handleSelect = (key) => {
    setActiveKey(key) // update active tab
  }

  return (
    <div className="page-wrapper">
      <div className="content">
        <Tab.Container id="left-tabs-example" activeKey={activeKey} onSelect={handleSelect}>
          <div className="page-header">
            <div className="content-page-header">
              <h5>Reports</h5>

              <div className="list-btn">
                <Nav className="d-flex gap-1">
                  <Nav.Item className={`btn btn-small ${activeKey === 'region' ? 'btn-primary' : 'common-outline-btn'}`}>
                    <Nav.Link className={`text-${activeKey === 'region' ? 'white' : 'black'} p-0`} eventKey="region">
                      Region
                    </Nav.Link>
                  </Nav.Item>
                  {hasAccess('reportGeneralTab', getUserRole()) && (
                    <Nav.Item className={`btn btn-small ${activeKey === 'general' ? 'btn-primary' : 'common-outline-btn'}`}>
                      <Nav.Link className={`text-${activeKey === 'general' ? 'white' : 'black'} p-0`} eventKey="general">
                        General
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </Nav>
              </div>
            </div>
          </div>
          <Tab.Content>
            {hasAccess('reportGeneralTab', getUserRole()) && activeKey === 'general' && (
              <Tab.Pane eventKey="general">
                <General />
              </Tab.Pane>
            )}

            {activeKey === 'region' && (
              <Tab.Pane eventKey="region">
                <Region />
              </Tab.Pane>
            )}
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  )
}

export default Reports
